import moment from 'moment';
import { VehicleFirst } from 'src/utils/interfaces/interfaces';
import { useTranslation } from 'react-i18next';
import { UAEStatesMap } from 'src/data/States';
import { FaCalendarDays, FaHashtag, FaRegIdBadge, FaTruck } from 'src/icons';

type IVehicleProps = { vehicle: VehicleFirst };

export default function VehicleCard({ vehicle }: IVehicleProps) {
  const { t } = useTranslation();

  const plateNumber = vehicle.plateNumber
    ? (vehicle?.plate?.emirates
      ? `${UAEStatesMap[vehicle?.plate.emirates as keyof typeof UAEStatesMap]
        ?.code || ''
      }-`
      : '') + vehicle.plateNumber.replace('private-', '')
    : 'N/A';

  const detailItems = [
    {
      label: t('vehicle.make'),
      value: vehicle?.vehicleMake || 'Unknown',
      icon: <FaTruck className="text-base" />,
    },
    {
      label: t('vehicle.model'),
      value: vehicle?.model || 'N/A',
      icon: <FaRegIdBadge className="text-base" />,
    },
    {
      label: t('vehicle.plate_no'),
      value: plateNumber,
      icon: <FaHashtag className="text-base" />,
    },
    {
      label: t('vehicle.chassis'),
      value: vehicle?.chassis || 'N/A',
      icon: <FaRegIdBadge className="text-base" />,
    },
    {
      label: t('vehicle.mulkiya_expiry'),
      value: vehicle?.mulkiya
        ? moment(vehicle.mulkiya).format('DD/MM/YYYY')
        : 'N/A',
      icon: <FaCalendarDays className="text-base" />,
    },
  ];

  return (
    <div
      className="rounded-lg border px-6 py-4 shadow-card"
      style={{
        backgroundColor: 'var(--bg-surface-2)',
        borderColor: 'var(--border-light)',
      }}
    >
      <div
        className="py-4 text-center border-b"
        style={{ borderColor: 'var(--border-light)' }}
      >
        <div
          className="rounded-full w-fit mx-auto p-4 mb-2"
          style={{
            backgroundColor: 'var(--color-primary-light)',
            color: 'var(--color-primary)',
            border: '1px solid color-mix(in srgb, var(--color-primary) 20%, transparent)',
          }}
        >
          <FaTruck className="text-[34px]" />
        </div>
        <p className="text-lg capitalize" style={{ color: 'var(--text-main)' }}>
          {plateNumber}
        </p>
      </div>
      {detailItems.map((item) => (
        <div
          key={item.label}
          className="grid grid-cols-6 py-4 border-b"
          style={{ borderColor: 'var(--border-light)' }}
        >
          <div
            className="my-auto mx-auto flex h-9 w-9 items-center justify-center rounded-lg"
            style={{
              backgroundColor: 'var(--color-primary-light)',
              color: 'var(--color-primary)',
            }}
          >
            {item.icon}
          </div>
          <div className="col-span-5">
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
              {item.label}
            </p>
            <p className="text-sm break-words" style={{ color: 'var(--text-main)' }}>
              {item.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
